import React, { FC } from 'react'
import { PortableTextBodyElement } from '../../utilities/blockContent'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { Box } from '../Box'
import { SignupForm } from './SignupForm'

export interface SignupFormBoxProps {
  description: string
  disclaimer?: PortableTextBodyElement[]
  heading?: string
}

export const SignupFormBox: FC<SignupFormBoxProps> = ({
  description,
  disclaimer,
  heading,
}) => (
  <Box padding="p-30 sm:px-90 sm:py-60" paddingStyle="custom" variant="border">
    <div className="text-secondary-darker">
      {(!isNullOrWhiteSpace(heading) || !isNullOrWhiteSpace(description)) && (
        <div className="mb-30 sm:mr-45">
          {!isNullOrWhiteSpace(heading) && (
            <h2 className="mb-10 font-t text-t-500 tb:text-t-600">{heading}</h2>
          )}
          {!isNullOrWhiteSpace(description) && (
            <p className="font-t text-t-300">{description}</p>
          )}
        </div>
      )}

      <SignupForm disclaimer={disclaimer} />
    </div>
  </Box>
)
